import React, { useState, useEffect, useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
// import {
// AppSidebar,
// AppFooter,
// AppHeader,
// AppHeaderDashboard,
// } from '../components/index'
// import Landing from 'src/components/Landing'
import CIcon from '@coreui/icons-react'
import { cilSignalCellular0, cilWifiSignalOff, cilXCircle } from '@coreui/icons'
import handleErr from 'src/utils/handle-error'
import isEmpty from 'src/utils/is-empty'
// import speedTest from 'src/utils/speed-test'
// import { todayRange } from 'src/utils/handle-date'

// import AppSidebar from 'src/components/AppSidebar'
// import AppContent from 'src/components/AppContent'
// import AppHeaderDashboard from 'src/components/AppHeaderDashboard'
const AppContent = React.lazy(() => import('../components/AppContent'))
const AppSidebar = React.lazy(() => import('../components/AppSidebar'))
const AppHeader = React.lazy(() => import('../components/AppHeader'))
const AppFooter = React.lazy(() => import('../components/AppFooter'))
const Landing = React.lazy(() => import('src/components/Landing'))

const DefaultLayout = ({ socket, companyByDomain, installProps }) => {
  const location = useLocation()
  // const navigate = useNavigate()
  const { userInfo } = useSelector((state) => state.companyAuth)
  const {
    tripsList,
    // inspectionsList, vehiclesList, companySettings
  } = useSelector((state) => state.admin)

  const [offLine, setOffLine] = useState(!navigator?.onLine)
  const [slowNetwork, setSlowNetwork] = useState(null)
  const [networkSpeed, setNetworkSpeed] = useState(null)

  const connex = useMemo(() => ({ type: navigator?.connection?.effectiveType }), [])

  // const getSpeedTest = async () => await speedTest

  const updateConnectionStatus = useCallback(() => {
    try {
      if (slowNetwork === null || connex.type !== navigator?.connection?.effectiveType) {
        // if (navigator?.onLine) {
        // console.log(navigator?.connection?.downlink)
        // console.log(navigator?.connection)
        // speedTest()
        // speedTest().then((networkSpeed) => {
        //   console.log(networkSpeed)
        //   if (
        //     networkSpeed?.speedMbps &&
        //     networkSpeed?.speedMbps < 1 &&
        //     networkSpeed?.speedMbps > 0
        //   ) {
        //     setSlowNetwork(true)
        //     setNetworkSpeed(networkSpeed?.speedMbps)
        //   } else {
        //     setSlowNetwork(false)
        //     setNetworkSpeed(null)
        //   }
        // })
        // }

        setNetworkSpeed(navigator?.connection?.downlink)

        console.log(
          `Connection type changed from ${connex.type} to ${navigator?.connection?.effectiveType} ${navigator?.connection?.downlink}Mbs`,
        )
        connex.type = navigator?.connection?.effectiveType
        if (
          connex.type === '2g' ||
          ((!isEmpty(navigator?.connection?.downlink) || navigator?.connection?.downlink === 0) &&
            navigator?.connection?.downlink < 1)
        ) {
          setSlowNetwork(true)
        } else {
          setSlowNetwork(false)
        }
      }
    } catch (err) {
      handleErr({ err })
    }
  }, [connex, slowNetwork])

  useEffect(() => {
    try {
      // window.addEventListener(
      //   'visibilitychange',
      //   () => {
      //     if (document.visibilityState === 'visible') {
      //       updateConnectionStatus()
      //     }
      //   },
      //   false,
      // )
      window.addEventListener('online', () => {
        setOffLine(false)
      })
      window.addEventListener('offline', () => {
        setOffLine(true)
      })
    } catch (err) {
      handleErr({ err })
    }
  }, [])

  useEffect(() => {
    updateConnectionStatus()
    navigator?.connection?.addEventListener('change', updateConnectionStatus)
  }, [updateConnectionStatus])

  return !userInfo ? (
    <Landing companyByDomain={companyByDomain} installProps={installProps} />
  ) : (
    <>
      {offLine || slowNetwork ? (
        <div className={`offlinenotification ${!tripsList?.data?.length ? 'bg-danger' : ''}`}>
          {/* <div className={`offlinenotification ${tripsList?.data?.length ? 'p-0' : 'bg-danger'}`}> */}
          <CIcon icon={slowNetwork ? cilSignalCellular0 : cilWifiSignalOff} className="me-1" />
          <span className="w-fit fs-13">
            {slowNetwork
              ? `Weak Signal ${networkSpeed < 1 ? `${networkSpeed} Mbps` : ''}`
              : tripsList?.data?.length
              ? 'Working Offline'
              : 'Connection Error !!!'}
          </span>
          <CIcon
            className="ms-1"
            icon={cilXCircle}
            onClick={(e) => {
              e.preventDefault()
              setSlowNetwork(false)
            }}
          />
        </div>
      ) : null}
      {/* {location.pathname === '/' ? null : <AppSidebar />} */}
      <AppSidebar />
      <div className={`main-wrapper wrapper d-flex flex-column min-vh-100`}>
        {/* <div
        className={`main-wrapper wrapper d-flex flex-column min-vh-100 ${
          tripsList?.data?.length ? 'grad-light-blue' : 'grad-info'
        } `}
      > */}
        {/* {location.pathname === '/' ? <AppHeader /> : <AppHeader />} */}
        <AppHeader installProps={installProps} />
        <div className="body flex-grow-1 min-vh-100">
          <AppContent socket={socket} />
        </div>
        {/* <div className="body flex-grow-1 px-3 min-vh-100">{content}</div> */}
        {location.pathname === '/' ? null : <AppFooter companyByDomain={companyByDomain} />}
      </div>
    </>
  )
}

DefaultLayout.propTypes = {
  socket: PropTypes.any,
  companyByDomain: PropTypes.any,
  installProps: PropTypes.any,
}

export default React.memo(DefaultLayout)
